import React from "react";
interface SectionHeadingProps {
  id?: string;
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: "center" | "left";
  tone?: "light" | "dark";
}
export function SectionHeading({
  id,
  eyebrow,
  title,
  intro,
  align = "center",
  tone = "light"
}: SectionHeadingProps) {
  const center = align === "center";
  const dark = tone === "dark";
  return <div className={`${center ? "mx-auto text-center" : ""} max-w-3xl`} data-id="element-325" data-mp="s040nqagtsph">
      {eyebrow && <p className={`mb-3 text-sm font-semibold ${dark ? "text-sakura" : "text-terracota-deep"}`} data-id="element-326" data-mp="n0rfd9z8stp0">{eyebrow}</p>}
      <h2 id={id} className={`font-serif text-3xl font-medium leading-tight tracking-tight md:text-[2.75rem] md:leading-[1.1] ${dark ? "text-marfil" : "text-pizarra-deep"}`} data-id="element-327" data-mp="d8v6r4zj5l6j">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-base leading-relaxed md:text-lg ${dark ? "text-crema" : "text-pizarra-soft"}`} data-id="element-328" data-mp="47dp3i6h5bfq">{intro}</p>}
    </div>;
}